export const AUDIO_LIBRARY_CHANGED = 'bahlus-audio-library-changed';

export function notifyAudioLibraryChanged(detail) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AUDIO_LIBRARY_CHANGED, { detail }));
}

export function subscribeAudioLibraryChanged(handler) {
  if (typeof window === 'undefined') return () => {};
  const listener = (event) => handler(event?.detail);
  window.addEventListener(AUDIO_LIBRARY_CHANGED, listener);
  return () => window.removeEventListener(AUDIO_LIBRARY_CHANGED, listener);
}
